/** Render only the author-safe failure fields returned by the Flow service. */
import React from 'react';
import { Message } from 'semantic-ui-react';

const stages = {
  compile: 'The questionnaire could not be prepared as a Flow',
  meta_check: 'The Flow status could not be checked with Meta',
  meta_create: 'The Flow could not be created in Meta',
  meta_upload: 'The WhatsApp screens could not be uploaded to Meta',
  store_package: 'The prepared Flow could not be saved',
  verify_source: 'The questionnaire changed while the Flow was being prepared',
  submit_review: 'The questionnaire could not be submitted for review',
};
const text = value => typeof value === 'string' && value.trim() ? value.trim() : '';
export const flowFailureMessage = (result, fallback) => {
  const diagnostic = (Array.isArray(result?.diagnostics) ? result.diagnostics : [])
    .find(item => item && item.severity !== 'warning' && text(item.message));
  return text(result?.errorMessage) || text(diagnostic?.message) ||
    text(result?.errorDetails?.message) || text(result?.errorDetails) || fallback;
};
export default function FlowOperationFailure({ result, fallback }) {
  const reason = flowFailureMessage(result, fallback);
  if (!reason) return null;
  return <Message visible negative>
    <Message.Header>{stages[result?.errorStage] || 'The latest Flow is not ready'}</Message.Header>
    <p>{reason}</p>
    <p>Your saved questionnaire edits are kept.</p>
  </Message>;
}
